import { signIn, signUp, logout, fetchUsers, fetchUser, updateAccess, createUser, updateUser } from '@/api/auth.api';
import { USER_ROLE } from '@/helpers/constants/app.constants';

export default {
  namespaced: true,
  state: {
    user: {},
    allUsers: []
  },

  getters: {
    isAdminUser(state) {
      return state.user.role === USER_ROLE.ADMIN.id;
    },
    
    isPurchaseUser(state) {
      return state.user.role === USER_ROLE.PURCHASER.id;
    },
    
    isApproverUser(state) {
      return state.user.role === USER_ROLE.APPROVER.id;
    },
    
    isFinanceUser(state) {
      return state.user.role === USER_ROLE.FINANCE.id;
    },
    
    isRequesterUser(state) {
      return state.user.role === USER_ROLE.GENERAL.id;
    },

    userFullName(state) {
      return `${state.user.firstName} ${state.user.lastName}`;
    },
    
    getUserById: (state) => (id) => {
      return state.users.find(user => user.id === id);
    },
    
    getUsersBySectorId: (state) => (sectorId) => {
      return state.users.filter(user => user.sectorId === sectorId);
    },
    
    getUsersByRole: (state) => (role) => {
      return state.users.filter(user => user.role === role);
    },
    
    getActiveUsers(state) {
      return state.users.filter(user => user.active);
    }
  },

  mutations: {
    setUser: (state, user) => {
      state.user = user;
    },
    
    setAllUsers: (state, users) => {
      state.allUsers = users;
    },
    
    addUser: (state, user) => {
      state.users.push(user);
    },
    
    updateUser: (state, updatedUser) => {
      const index = state.users.findIndex(user => user.id === updatedUser.id);
      if (index !== -1) {
        state.users.splice(index, 1, updatedUser);
      }
    },
    
    removeUser: (state, userId) => {
      state.users = state.users.filter(user => user.id !== userId);
    }
  },

  actions: {
    async initAllUsers({ commit }) {
      const { success, data, error } = await fetchUsers();

      if (success) {
        commit('setAllUsers', data);

        return { success: true };
      }

      return { success: false, error };
    },

    async getUser({ commit }) {
      const { success, data, error } = await fetchUser();

      if (success) {
        commit('setUser', data);

        return { success: true };
      }

      return { success: false, error };
    },

    async updateAccess({ state, commit }, { id, access }) {
      const { success, error } = await updateAccess(id, access);

      if (success) {
        const allUsers = Array.from(state.allUsers);
        const userIndex = allUsers.findIndex(user => user.id === id);
        allUsers[userIndex].access = access;

        commit('setAllUsers', allUsers);
      }

      return { success, error };
    },

    async createUser({ state, commit }, payload) {
      const { success, error, user } = await createUser({
        ...payload,
        id: undefined,
        confirmPassword: undefined,
        sector: undefined
      });

      if (success) {
        const allUsers = Array.from(state.allUsers);
        allUsers.push(user);

        commit('setAllUsers', allUsers);

        return { success: true };
      }

      return { success: false, error };
    },

    async updateUser({ state, commit }, payload) {
      const { success, error } = await updateUser({
        ...payload,
        confirmPassword: undefined,
        sector: undefined
      });

      if (success) {
        const allUsers = Array.from(state.allUsers);
        const userIndex = allUsers.findIndex(user => user.id === payload.id);
        allUsers[userIndex] = payload;  

        commit('setAllUsers', allUsers);

        return { success: true };
      }

      return { success: false, error };
    },

    async login({ commit }, payload) {
      const { success, data, error } = await signIn(payload);

      if (success && !data.status) {
        commit('setUser', data.user);
        localStorage.setItem('token', data.tokens.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));

        return { success: true };
      }

      return { success: false, error };
    },

    async register({ commit }, payload) {
      const { success, data, error } = await signUp(payload);

      if (success && !data.status) {
        commit('setUser', data.user);
        localStorage.setItem('token', data.tokens.access_token);
        localStorage.setItem('user', JSON.stringify(data.user));

        return { success: true };
      }

      return { success: false, error };
    },

    async logout({ commit }) {
      const { success, error } = await logout();

      if (success) {
        commit('setUser', {});
        localStorage.removeItem('token');
        localStorage.removeItem('user');

        return { success: true };
      } else {
        console.error(error);
        return { success: false, error };
      }
    }
  },
};
